import { Formik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import * as Yup from 'yup';
import VerifyFamilyForm from './VerifyFamilyForm';
import CardHeader from 'react/shared/components/true_link/main/form/wizard/CardHeader';
import NextPageButton from 'react/shared/components/true_link/main/form/wizard/NextPageButton';
import schema from 'react/shared/utils/schemas';
import PatriotActCard from 'react/signups/card/common/PatriotActCard';
import WizardCard from 'react/signups/card/common/WizardCard';
import verificationDataShape from 'react/signups/card/shapes/VerificationData';

export default function VerifyFamily({
  firstName,
  moduleComplete,
  verificationData,
  setVerificationData,
}) {
  const validationSchema = Yup.object().shape({
    ssn: schema.ssn.required(),
    ssnConfirmation: schema.ssnConfirmation.required(),
    dateOfBirth: schema.dateOfBirth.required(),
  });

  const handleContinue = (values) => {
    setVerificationData({
      ssn: values.ssn,
      ssnConfirmation: values.ssnConfirmation,
      dateOfBirth: values.dateOfBirth,
    });
  };

  return (
    <>
      <WizardCard>
        <CardHeader>Almost there {firstName}! Time to verify your identity.</CardHeader>
        <Formik
          initialValues={verificationData}
          onSubmit={handleContinue}
          validationSchema={validationSchema}
        >
          {({ handleChange, handleSubmit, setFieldTouched, values }) => (
            <>
              <VerifyFamilyForm
                onChange={handleChange}
                setFieldTouched={setFieldTouched}
                values={values}
              />
              <NextPageButton disabled={moduleComplete} onClick={handleSubmit} />
            </>
          )}
        </Formik>
      </WizardCard>
      <p />
      <PatriotActCard />
    </>
  );
}

VerifyFamily.propTypes = {
  firstName: PropTypes.string.isRequired,
  moduleComplete: PropTypes.bool.isRequired,
  verificationData: verificationDataShape.isRequired,
  setVerificationData: PropTypes.func.isRequired,
};
